import React from 'react';
import {Textbox} from 'src/design/atoms/Textbox';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    onChange(event.target.value);
  };

  return (
    <Textbox
      label="Search Value"
      placeholder="Enter search value..."
      value={value}
      onChangeCallback={handleChange}
      disabled={disabled}
    />
  );
};
